module.exports = __webpack_public_path__ + "img/my-coin-ball.fe6faba2.png";